import React from 'react'
import {
  AlignItems,
  Body2,
  Bold,
  Box,
  Display,
  Heading2,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import foodBoxMobileWebp from '../../assets/foodbox-mobile.webp'
import foodBoxDesktopWebp from '../../assets/foodbox-desktop.webp'
import foodBoxJpeg from '../../assets/foodbox.jpg'
import { OrderedCol } from '../OrderedCol'
import { ResponsiveImage } from '../../../../../components/ResponsiveImage'

export function FoodBoxIntroduction() {
  return (
    <>
      <OrderedCol order={1}>
        <Box paddingRight={10}>
          <Heading2>So, what’s a food box anyway?</Heading2>
          <Space size={3} />
          <Body2 size={4}>
            <Bold>Discover Gousto&apos;s fresh take on mealtimes.</Bold> Think of it as dinner made
            way easier. A Gousto food box is a meal kit packed with fresh ingredients, delivered
            right to your door—no more last-minute dashes to the shop or guessing how much coriander
            to use.
          </Body2>
          <Space size={6} />
          <Body2 size={4}>
            Just pick the recipes you fancy, and we’ll send you exactly what you need (down to the
            last clove of garlic) along with easy-to-follow cooking steps. No waste, no stress, just
            tasty meals made simple.
          </Body2>
          <Space size={6} />
          <Body2 size={4}>
            That’s why subscription food boxes are a super convenient and budget-friendly
            alternative to the weekly supermarket scramble.
          </Body2>
          <Space size={[6, null, null, 0]} />
        </Box>
      </OrderedCol>
      <OrderedCol
        order={2}
        display={Display.Flex}
        alignItems={AlignItems.FlexStart}
        justifyContent={JustifyContent.Center}
      >
        <Box maxWidth={[null, null, null, '600px']} width="100%">
          <ResponsiveImage
            mobileWebp={foodBoxMobileWebp}
            desktopWebp={foodBoxDesktopWebp}
            fallbackSrc={foodBoxJpeg}
            style={{ maxHeight: '457px' }}
            fit="cover"
            alt="Gousto recipe box containing vegetables, meat, spices, and recipe cards, next to a creamy tomato sauce pasta cooked recipe."
          />
        </Box>
      </OrderedCol>
    </>
  )
}
